import { Clock, CheckCircle2, Loader2 } from 'lucide-react';

interface SaveStateChipProps {
  isDirty: boolean;
  submitting: boolean;
  lastSavedAt: Date | null;
}

const formatTime = (d: Date) =>
  d.toLocaleTimeString('el-GR', { hour: '2-digit', minute: '2-digit' });

/**
 * Notion/Linear-style indicator near the submit button. Three states:
 *   - submitting  → spinner + "Υποβολή..."
 *   - isDirty     → orange clock + last-saved time (or "Μη αποθηκευμένα" if never saved)
 *   - clean       → green check + last-saved time (or "Καμία αλλαγή ακόμη")
 */
export const SaveStateChip = ({ isDirty, submitting, lastSavedAt }: SaveStateChipProps) => {
  if (submitting) {
    return (
      <span className="flex items-center text-sm text-blue-600">
        <Loader2 className="w-4 h-4 mr-1 animate-spin" />
        Υποβολή...
      </span>
    );
  }

  if (isDirty) {
    return (
      <span className="flex items-center text-sm text-orange-600">
        <Clock className="w-4 h-4 mr-1" />
        {lastSavedAt
          ? `Μη αποθηκευμένα · τελευταία αποθήκευση ${formatTime(lastSavedAt)}`
          : 'Μη αποθηκευμένες αλλαγές'}
      </span>
    );
  }

  return (
    <span className="flex items-center text-sm text-green-600">
      <CheckCircle2 className="w-4 h-4 mr-1" />
      {lastSavedAt ? `Αποθηκεύτηκε · ${formatTime(lastSavedAt)}` : 'Καμία αλλαγή ακόμη'}
    </span>
  );
};
